import { isDocumentDefined } from "../element/isDocumentDefined";

export function getCookie(name: string): string | undefined {
  if (!isDocumentDefined()) {
    return undefined;
  }

  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));

  return match ? decodeURIComponent(match[2]) : undefined;
}
